// extracted by mini-css-extract-plugin
export var notificationHost = "_c6-0";